import { CommonAPIService } from "@/serviceHandlers/CommonHandler";

export default class DirectorsAPIService {
  constructor() {
    this.commonAPIservice = new CommonAPIService();
  }

  getDirectorInfo(directorId, router) {
    const url = `/api/directors/${directorId}`;
    return this.commonAPIservice.getCall(url, "", router);
  }

  getDirectors(router) {
    const url = "/api/directors";
    return this.commonAPIservice.getCall(url, "", router);
  }

  createDirector(params, router) {
    const url = "/api/directors";
    return this.commonAPIservice.postCall(url, params, router);
  }

  updateDirector(directorId, params, router) {
    const url = `/api/directors/${directorId}`;
    return this.commonAPIservice.putCall(url, params, router);
  }

  deleteDirector(directorId, router) {
    const url = `/api/directors/${directorId}`;
    return this.commonAPIservice.deleteCall(url, "", router);
  }
}
